export default {
  config: null,
  alertsUrl:
    process.env.VUE_APP_ENV === "production"
      ? "https://alerts-api.omnifitrgsites.co.uk"
      : "https://alerts-api-stage.omnifitrgsites.co.uk",
  btUuid: null,
  modalIsVisible: false,
  activeModal: null,
  user: {
    email: null,
    name: null,
    phone: null,
    token: null,
  },
  paymentIds: {
    CreditCard: "Credit Card",
    PayPalAccount: "PayPal",
    PayPalCheckout: "PayPal",
    ApplePay: "Apple Pay",
    GooglePay: "Google Pay",
  },
  requiredCheckoutData: {
    basketId: null,
    btToken: null,
    basketTotal: null,
    promotionDiscount: null,
    voucherDiscount: null,
  },
  voucherDetail: null,
  paymentData: {
    deviceData: null,
    nonce: null,
    description: null,
    paymentType: null,
  },
  successData: {
    paidBy: null,
    uniqueRef: null,
    receiptEmail: null,
  },
  failureData: {
    message: null,
  },
  orderNumber: null,
};
